import { ManageSubscriptionScreen } from "@/app/modules/User";

export const ManageSubscription = () => <ManageSubscriptionScreen />;
